import { createFileRoute } from '@tanstack/react-router';

import { ListsCollectionPage } from '../features/supply/lists/components/ListsCollectionPage/ListsCollectionPage';
import { listsRouteSearchSchema } from '../features/supply/lists/listsRouteSearch';
import { SupplyListsTab } from '../features/supply/lists/model';

export const Route = createFileRoute('/supply/lists/rewrite')({
  validateSearch: listsRouteSearchSchema,
  component: () => <ListsCollectionPage tab={SupplyListsTab.Rewrite} />,
});
